import AppLayout from "../layouts/AppLayout";

export default function AboutUs() {
    return (
        <AppLayout>
            <div className="w-full">
                <article className="container max-w-dasha mx-auto px-4 sm:px-6 lg:px-8 py-20 pt-0 flex flex-col">
                    <h1 className="text-3xl font-bold mb-4 text-gray-900">About PriceHunt.ca</h1>
                    <p className="text-lg text-gray-700 mb-6">
                        PriceHunt.ca is an independent price comparison website that helps Canadians find the best deals on tech products. We track prices from multiple trusted retailers and bring them together in one simple interface — so you can spend less time searching and more time saving.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-2">Why we built this</h2>
                    <p className="text-gray-700 mb-4">
                        As tech enthusiasts ourselves, we often found it frustrating to check multiple websites just to compare prices on Televisions, PC components, and other electronics. PriceHunt was created to solve that — starting with computer parts, and expanding into more categories over time.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-2">How it works</h2>
                    <p className="text-gray-700 mb-4">
                        Our system automatically pulls product prices and availability from stores. We update prices daily to ensure the data stays fresh and accurate.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-2">What’s next</h2>
                    <p className="text-gray-700 mb-4">
                        We're working on adding more categories, filtering options, and user features like wishlists and price alerts. Our goal is to become the go-to tool for tech shoppers in Canada.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-2">Let’s connect</h2>
                    <p className="text-gray-700">
                        If you have feedback, feature requests, or just want to say hello — we’d love to hear from you. Use our <a href="/contact" className="text-blue-500 hover:underline">contact form</a> to get in touch.
                    </p>
                </article>
            </div >
        </AppLayout >
    )
}